export const ASSETS = {
  heroBg: "https://static.prod-images.emergentagent.com/jobs/a8a0adc5-6482-42c8-8971-319449d6d9cf/images/5e87bd6d6bf91fd3aa774c19475a90ef06c686c4384b89ccf591807393542074.png",
  shockwave: "https://static.prod-images.emergentagent.com/jobs/a8a0adc5-6482-42c8-8971-319449d6d9cf/images/755bc65913f6334468d0ef9d5fc3cf4ba64f0a68cf6d6b15b1e37b509526d41a.png",
  exomobil: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/user_6903bd58b663e4914099bb65/fffd782ae_Hypershell-exo-Pro-X.jpg",
  exomobil_action: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6964c4548def13950840ad0f/adc00fd36_WhatsAppImage2026-01-13at185023.jpg",
  titanium: "https://static.prod-images.emergentagent.com/jobs/a8a0adc5-6482-42c8-8971-319449d6d9cf/images/3e650e632867190d08b3a1d73cde32dfdfd83e1dad15cbb3ed78af3f8216f494.png",
  yacht: "https://images.unsplash.com/photo-1559385301-0187cb6eff46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHx5YWNodCUyMG1vbmFjbyUyMHN1bnNldHxlbnwwfHx8fDE3NzkwNDE3Mzl8MA&ixlib=rb-4.1.0&q=85",
  athlete1: "https://images.unsplash.com/photo-1754476195695-9a39e974bfd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxhdGhsZXRlJTIwcG9ydHJhaXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzkwNDE3NDB8MA&ixlib=rb-4.1.0&q=85",
  athlete2: "https://images.unsplash.com/photo-1754476262602-18e3abf04d60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxhdGhsZXRlJTIwcG9ydHJhaXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzkwNDE3NDB8MA&ixlib=rb-4.1.0&q=85",
  logo1: "https://images.unsplash.com/photo-1760553120763-db550ae7b165?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBicmFuZCUyMGxvZ28lMjB3aGl0ZXxlbnwwfHx8fDE3NzkwNDE3Mzl8MA&ixlib=rb-4.1.0&q=85",
  logo2: "https://images.unsplash.com/photo-1759563876899-066656b3837f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBicmFuZCUyMGxvZ28lMjB3aGl0ZXxlbnwwfHx8fDE3NzkwNDE3NDB8MA&ixlib=rb-4.1.0&q=85",
};

// Tarifs officiels — Plaquette Riviera Shockwaves
// Séance individuelle · Déplacement · Capacité journée
export const TREATMENTS = [
  {
    key: "individual",
    fr: "Séance individuelle",
    en: "Individual session",
    it: "Sessione individuale",
    ru: "Индивидуальный сеанс",
    desc_fr: "Une séance d'1 h par personne. Notre thérapie signature combinant 7 stimulations adaptées à votre objectif.",
    desc_en: "1-hour session per person. Our signature therapy combining 7 stimulations tailored to your objective.",
    desc_it: "Una sessione di 1 ora a persona. La nostra terapia signature con 7 stimolazioni adattate al vostro obiettivo.",
    desc_ru: "Сеанс 1 час на человека. Наша сигнатурная терапия с 7 стимуляциями под вашу цель.",
    price: "1 500 €",
    price_unit_fr: "par personne · séance d'1 h",
    price_unit_en: "per person · 1-hour session",
    price_unit_it: "a persona · sessione di 1 h",
    price_unit_ru: "с человека · сеанс 1 час",
  },
  {
    key: "deployment",
    fr: "Déplacement",
    en: "Deployment",
    it: "Trasferta",
    ru: "Выезд",
    desc_fr: "Intervention sur votre lieu de vie ou de séjour — yacht, villa, hôtel, club ou événement privé. Hélicoptère jusqu'à 400 km via nos partenaires aériens. Tarif sur devis selon destination.",
    desc_en: "We operate at your home or stay location — yacht, villa, hotel, club or private event. Helicopter up to 400 km via our air partners. Quoted per destination.",
    desc_it: "Interveniamo sul vostro luogo di vita o soggiorno — yacht, villa, hotel, club o evento privato. Elicottero fino a 400 km tramite i nostri partner aerei. Tariffa su preventivo in base alla destinazione.",
    desc_ru: "Работаем там, где вы живёте или отдыхаете — яхта, вилла, отель, клуб или частное мероприятие. Вертолёт до 400 км через наших авиапартнёров. Стоимость по запросу в зависимости от направления.",
    price: "Sur devis",
    price_en: "On quote",
    price_it: "Su preventivo",
    price_ru: "По запросу",
    price_unit_fr: "selon destination & durée",
    price_unit_en: "based on destination & duration",
    price_unit_it: "in base a destinazione e durata",
    price_unit_ru: "зависит от направления и длительности",
  },
  {
    key: "capacity",
    fr: "Capacité journée",
    en: "Daily capacity",
    it: "Capacità giornaliera",
    ru: "Дневная мощность",
    desc_fr: "10 à 12 personnes prises en charge selon l'équipe mobilisée et le planning convenu.",
    desc_en: "10 to 12 people handled depending on the team deployed and the agreed schedule.",
    desc_it: "Da 10 a 12 persone gestite in base al team e al programma concordato.",
    desc_ru: "От 10 до 12 человек в зависимости от команды и согласованного графика.",
    price: "10–12",
    price_unit_fr: "personnes par jour",
    price_unit_en: "people per day",
    price_unit_it: "persone al giorno",
    price_unit_ru: "человек в день",
  },
];

export const PARTNER_TARGETS = [
  { num: "01", title_fr: "Capitaineries ports & marinas", title_en: "Harbor masters & marinas" },
  { num: "02", title_fr: "Conciergeries yachts & hôtels", title_en: "Yacht & hotel concierges" },
  { num: "03", title_fr: "Professionnels santé & sport", title_en: "Health & sports professionals" },
  { num: "04", title_fr: "Agents VIP luxury travel", title_en: "VIP luxury travel agents" },
];

export const BRAND_INFO = {
  whatsapp: "+33 7 86 44 82 47",
  email: "contact@riviera-shockwaves.com",
  instagram: "https://www.instagram.com/rivierashockwaves?utm_source=qr&stkn=MWoycGc3Z2EyYWxrZQ==",
  locations: ["Cala del Forte", "Monaco", "Cannes", "Saint-Tropez"],
  exomobil_url: "https://www.exomobil.com",
  xp_therapy_url: "https://xp-therapy.com",
  medmaiora_url: "https://www.rivierawellnesscenter.com",
};
